import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { EventService } from "src/service/event.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { Router } from "@angular/router";
import { OptionTypeDisplayed } from "src/model/enum/enumOptionTypeDisplayed";
import { Platform, PopoverController } from "@ionic/angular";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { SystemRouterService } from "src/service/system-router.service";
import { ThemeService } from "src/service/theme.service";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";

@Component({
    selector: "app-popover-options",
    templateUrl: "./popover-options.component.html",
    styleUrls: ["./popover-options.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopoverOptionsComponent
  implements OnInit, OnDestroy, iTranslation {
  private _translateSubscription: Subscription = null;

  constructor(
    private _translateService: TranslateService,
    private _systemRouterService: SystemRouterService,
    private _popoverController: PopoverController,
    public platform: Platform,
    private _themeService: ThemeService
  ) {
    //this.InitializeTranslation();
  }

  /**
   * Number passed in follow eventService event is the same of the homepage block
   */
  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
  }

  //#region Translation
  public loadTranslation(): void { }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  /**
   * Navigate to system settings
   */
  public onClickGoToSettings(): void {
    this._systemRouterService.navigateToSystemOptionSettings();

    this._popoverController.dismiss();
  }

  /**
   * Navigate to backup settings
   */
  public onClickGoToBackupSettings(): void {
    this._systemRouterService.navigateToSystemBackupSettings();

    this._popoverController.dismiss();
  }

  /**
   * Navigate to restore settings
   */
  public onClickGoToRestoreSettings(): void {
    //this._systemRouterService.navigateToSystemRestoreSettings();
    const fileChooserElement = document.getElementById("fileRestore");
    if (fileChooserElement) {
      fileChooserElement.click();
    }

    this._popoverController.dismiss("restore");
  }
}
